import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../utils/rel';

class TabContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.tab_content}>
                <div className={styles.content}>
                    <a href={content[0].url} target="_blank" rel={rel}>
                        <img src={content[0].src} alt={content[0].title} title={content[0].title} />
                    </a>
                </div>
                <ul>
                    {content.slice(1).map((item, index) => (
                        <li key={index}>
                            <a href={item.url} target="_blank" rel={rel}>
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(TabContent);
